import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Stack } from "@mui/system";
import { Box, Typography, useTheme } from "@mui/material";
import fr from "../images/fr.png";
import en from "../images/en.png";

const DownloadCV = ({}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();

  const cvDownloads = [
    {
      link: "https://drive.google.com/file/d/1zVg7iIdyeCAbHyh_43iLwVWlBqJYfnYi/view?usp=sharing",
      img: en,
      title: "English",
    },
    {
      link: "https://drive.google.com/file/d/1Med7QDLQk4pYLGPHksEyFKzC_iiCbYNT/view?usp=sharing",
      img: fr,
      title: "French",
    },
  ];

  return (
    <Box
      sx={{
        py: ".2rem",
        cursor: "pointer",
      }}
    >
      <Typography
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: theme.palette.common.black,
          fontSize: "14px",
          fontWeight: theme.typography.fontWeightBold,
          "&:hover": {
            // color: "rgba(0, 0, 0, 0)",
          },
        }}
      >
        Download my CV
      </Typography>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
          left: "1rem",
        }}
      >
        {cvDownloads?.map((target) => {
          return (
            <MenuItem>
              <a
                href={target?.link}
                style={{
                  textDecoration: "none",
                  width: "100%",
                }}
              >
                {" "}
                <Stack
                  direction={"row"}
                  sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={target?.img}
                    alt="flag"
                    style={{
                      width: "1rem",
                    }}
                  />
                  <Typography sx={{ fontSize: "12px", ml: "1rem" }}>
                    {target?.title}
                  </Typography>
                </Stack>
              </a>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

export default DownloadCV;
